import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Shield, Crown, Handshake } from "lucide-react";

export function OffresTeaser() {
  return (
    <section className="py-20 bg-[#2C1E14] overflow-hidden" data-testid="offres-teaser-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <motion.p initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-[#C9922A] uppercase tracking-[0.2em] text-sm font-semibold mb-3">
            Propriétaires
          </motion.p>
          <motion.h2 initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }} className="text-3xl md:text-4xl text-white mb-4">
            Deux formules, une seule promesse
          </motion.h2>
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.2 }} className="text-white/40 max-w-lg mx-auto text-sm">
            La tranquillité totale. Choisissez l'offre qui vous correspond.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="relative group">
            <div className="absolute -inset-px rounded-2xl bg-gradient-to-br from-[#C9922A] via-[#E8C874] to-[#C9922A] opacity-50 group-hover:opacity-80 transition-opacity duration-500 blur-[1px]" />
            <div className="relative bg-[#1A120B] rounded-2xl p-7 border border-[#C9922A]/30">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <Shield className="w-6 h-6 text-[#C9922A]" />
                  <h3 className="font-display text-xl text-white">Offre Sérénité</h3>
                </div>
                <span className="inline-flex items-center gap-1 bg-gradient-to-r from-[#C9922A] to-[#E8C874] text-[#1A120B] text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                  <Crown className="w-3 h-3" /> Favori
                </span>
              </div>
              <p className="text-white/60 text-sm mb-4">Sous-location professionnelle</p>
              <p className="text-white font-medium mb-5">Loyer fixe garanti chaque mois, zéro gestion.</p>
              <Link to="/sous-location" className="inline-flex items-center gap-2 text-[#C9922A] text-sm font-semibold hover:text-[#E8C874] transition-colors" data-testid="teaser-serenite-link">
                Découvrir <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: 0.15 }} className="group">
            <div className="bg-white/[0.04] rounded-2xl p-7 border border-white/[0.08] hover:border-white/15 transition-all duration-500 h-full">
              <div className="flex items-center gap-3 mb-4">
                <Handshake className="w-6 h-6 text-white/50" />
                <h3 className="font-display text-xl text-white">Offre Partenariat</h3>
              </div>
              <p className="text-white/40 text-sm mb-4">Conciergerie en mandat</p>
              <p className="text-white/70 font-medium mb-5">Revenus maximisés selon la saisonnalité.</p>
              <Link to="/conciergerie-privee" className="inline-flex items-center gap-2 text-white/50 text-sm font-semibold hover:text-white/80 transition-colors" data-testid="teaser-partenariat-link">
                Découvrir <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
